export default "__VITE_ASSET__xlLbu7MD__"